/**
 * Created by Tengfei Li on 2026-01-20
 *
 */
import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import Styles from '../config/css/ConfigManager.module.scss';
import i18n from 'i18next';
import UnsentDevicesTab from './device-tabs';
import SentDevicesTab from './sent-devices-tab';
import { useLocation } from 'react-router-dom';

const { TabPane } = Tabs;

function DeviceManager() {
  const location = useLocation();
  const [activeKey, setActiveKey] = useState('unsent');
  const [configFilter, setConfigFilter] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveKey(location.state.activeTab);
      if (location.state.privateConfigId) {
        setConfigFilter(location.state.privateConfigId);
      }
    }
  }, [location.state]);

  const handleTabChange = (key) => {
    setActiveKey(key);
    setRefreshKey(prev => prev + 1);
  };

  return (
    <div className={Styles.container}>
      <Tabs activeKey={activeKey} onChange={handleTabChange}>
        <TabPane tab={i18n.t('unsent_devices')} key="unsent">
          <UnsentDevicesTab key={`unsent-${activeKey === 'unsent' ? refreshKey : 0}`} />
        </TabPane>
        <TabPane tab={i18n.t('sent_devices')} key="sent">
          <SentDevicesTab
            key={`sent-${activeKey === 'sent' ? refreshKey : 0}`}
            initialConfigId={activeKey === 'sent' ? configFilter : null}
          />
        </TabPane>
      </Tabs>
    </div>
  );
}

export default DeviceManager;
